(() => {
  if (window.svChatControlsReady) return;
  window.svChatControlsReady = true;
  const dismiss = document.querySelector('[data-sv-chat-dismiss]');
  const restore = document.querySelector('[data-sv-chat-restore]');
  const controls = document.querySelector('[data-sv-chat-controls]');
  if (!dismiss || !restore || !controls) return;
  let dismissed = false, host = null, lastRect = null, frame = 0;
  try { dismissed = sessionStorage.getItem('sv-chat-dismissed') === '1'; } catch (_) {}
  function label(text) { if (restore.textContent !== text) restore.textContent = text; }
  function overlaps(a, b) { return b.width > 0 && b.height > 0 && a.left < b.right + 8 && a.right > b.left - 8 && a.top < b.bottom + 8 && a.bottom > b.top - 8; }
  function refresh() {
    frame = 0;
    host = document.querySelector('#ShopifyChat') || document.querySelector('shopify-chat');
    if (!host) { dismiss.hidden = true; controls.hidden = true; return; }
    controls.hidden = false;
    if (dismissed) { host.classList.add('sv-chat-hidden'); dismiss.hidden = true; label('Show chat'); return; }
    const r = host.getBoundingClientRect();
    if (r.width > 0 && r.height > 0) lastRect = {left:r.left, right:r.right, top:r.top, bottom:r.bottom, width:r.width, height:r.height};
    if (!lastRect || lastRect.height > 120 || lastRect.width > 220) {
      host.classList.remove('sv-chat-hidden'); dismiss.hidden = true; label('Hide chat button'); return;
    }
    const bounds = { ...lastRect, right: Math.min(window.innerWidth, lastRect.right + 48) };
    const busy = [...document.querySelectorAll('media-gallery .slider-button, .product-form__buttons, #cart-icon-bubble, .cart__ctas, .menu-drawer-container[open], details[open] .search-modal, cart-drawer.active')]
      .some(el => overlaps(bounds, el.getBoundingClientRect()));
    host.classList.toggle('sv-chat-hidden', busy);
    dismiss.hidden = busy;
    label('Hide chat button');
    if (!busy) {
      dismiss.style.left = Math.max(4, Math.min(window.innerWidth - 48, lastRect.right + 4)) + 'px';
      dismiss.style.top = Math.max(4, Math.min(window.innerHeight - 48, lastRect.bottom - 44)) + 'px';
    }
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(refresh); }
  function setDismissed(value) {
    dismissed = value;
    try { sessionStorage.setItem('sv-chat-dismissed', value ? '1' : '0'); } catch (_) {}
    if (!value && host) { host.classList.remove('sv-chat-hidden'); lastRect = null; }
    refresh();
  }
  dismiss.addEventListener('click', () => { setDismissed(true); document.activeElement?.blur(); });
  restore.addEventListener('click', () => setDismissed(!dismissed));
  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', () => { if(host && !dismissed) host.classList.remove('sv-chat-hidden'); lastRect = null; schedule(); }, {passive:true});
  new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true});
  document.addEventListener('click', schedule);
  refresh();
})();